import { render, staticRenderFns } from "./ChatsTabSidebar.vue?vue&type=template&id=efb2f11c&scoped=true"
import script from "./ChatsTabSidebar.vue?vue&type=script&lang=js"
export * from "./ChatsTabSidebar.vue?vue&type=script&lang=js"
import style0 from "./ChatsTabSidebar.vue?vue&type=style&index=0&id=efb2f11c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb2f11c",
  null
  
)

export default component.exports